var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationAlert = function SvgSimpleIllustrationAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#400000",
    d: "M16.067 34.248H31.087c.517 0 .967.042 1.357.116 2.543.487 2.612 2.374 2.612 3.268v4.56H12.222v-4.56c0-.836.063-2.539 2.15-3.155.459-.135 1.017-.22 1.695-.226v-.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF3013",
    d: "M14.403 34.442c-.095-.294 1.927-17.167 1.927-17.167s.647-3.957 7.298-4.116c6.648.162 7.298 4.116 7.298 4.116s1.895 15.812 1.93 17.09c-.4-.075-.859-.117-1.385-.117h-.197c-.108-1.825-1.579-15.628-1.579-15.628s-.532-3.645-5.985-3.793c-5.456.148-5.985 3.793-5.985 3.793s-1.474 13.806-1.579 15.631c-.69.01-1.262.09-1.73.226l-.01-.032-.003-.003Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F25730",
    d: "M31.271 34.245H16.146c.105-1.826 1.58-15.631 1.58-15.631s.529-3.645 5.985-3.793c5.452.148 5.985 3.793 5.985 3.793s1.474 13.802 1.578 15.628l-.003.003Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.63 42.19h10.43v-4.561c0-.894-.07-2.78-2.562-3.268a7.019 7.019 0 0 0-1.331-.116h-7.282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.661 42.19h-12.44v-4.562c0-.835.064-2.538 2.194-3.154.47-.136 1.04-.22 1.731-.226h7.742M14.403 34.442c-.095-.294 1.927-17.167 1.927-17.167s.647-3.958 7.298-4.116c.136 0 .276-.003.418-.003"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32.854 34.442s.003-.036 0-.081c-.032-1.277-1.93-17.09-1.93-17.09s-.65-3.957-7.299-4.115c-.136 0-.275-.003-.418-.003"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAF0",
    d: "m22.502 27.671-4.051 2.552 2.219-4.12-4.147-1.277 4.34-1.177-2.602-4.12 4.241 2.256 1.158-4.22 1.157 4.22 3.953-2.255-2.22 4.022 4.147 1.177-4.146 1.078 2.412 4.219-4.245-2.452-1.058 4.513-1.158-4.416Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BF3013",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33.494 16.685h5.497M8.678 17.075h5.497M23.996 11.24V5.647M30.346 12.872l3.886-3.954M17.07 13.266 13.182 9.31"
  })));
};
export default SvgSimpleIllustrationAlert;